import type React from 'react';

import FlyInHeader from '../FlyInHeader/FlyInHeader';
import styles from './ProductSubstitutes.module.scss';
import type { ProductSubstitutesListProps } from './ProductSubstitutesList';
import ProductSubstitutesList, { ProductSubstitutesSkeletonList } from './ProductSubstitutesList';

type ProductSubstitutesProps = ProductSubstitutesListProps & {
    navigationSlot: React.ReactNode;
    belowHeaderSlot?: React.ReactNode;
    productName: string;
    isLoading: boolean;
};

const ProductSubstitutes = (props: ProductSubstitutesProps) => {
    return (
        <div className={styles.Container}>
            <FlyInHeader.Root
                heading="Välj ny vara"
                hideSubheaderBottomBorder
                navigationSlot={props.navigationSlot}
            >
                <FlyInHeader.Text className={styles.HeaderSubText}>
                    {`Välj vilken produkt du vill ersätta ${props.productName} med.`}
                </FlyInHeader.Text>
            </FlyInHeader.Root>
            {props.belowHeaderSlot}
            <div className={styles.SubstitutesContainer}>
                {props.isLoading ? (
                    <ProductSubstitutesSkeletonList />
                ) : (
                    <ProductSubstitutesList
                        substitutes={props.substitutes}
                        onProductSubstitution={props.onProductSubstitution}
                        priceType={props.priceType}
                    />
                )}
            </div>
        </div>
    );
};

export default ProductSubstitutes;
